export default {
  conversionPoint: {
    isLoading: false,
    data: {},
    status: null,
    error: false,
    errorMessage: null
  },
};
